var _a;
import { EWsStatus } from 'src/app/shared/enums/websocket-status.enum';
import connectedHandler from './connected.handler';
import receivedHandler from './received.handler';
import messagesHandler from './messages.handler';
import storedHandler from './stored.handler';
export default (_a = {},
    _a[EWsStatus.CONNECTED] = connectedHandler,
    _a[EWsStatus.RECEIVED] = receivedHandler,
    _a[EWsStatus.LOAD_CONVERSATION] = messagesHandler,
    _a[EWsStatus.NEW_MESSAGE] = messagesHandler,
    _a[EWsStatus.STORED] = storedHandler,
    _a);
